import type { SeatStatus } from "@/types/Seating";

/**
 * Tailwind chip classes for a seat status. Colors mirror the canvas seat dots
 * (see ChairDot.tsx) so the guest panel and canvas stay in sync.
 */
export function seatStatusChipClasses(status: SeatStatus): string {
  switch (status) {
    case "assigned":
      return "chip-green-bg chip-green-fg";
    case "checkedIn":
      return "chip-purple-bg chip-purple-fg";
    case "tentative":
      return "chip-blue-bg chip-blue-fg";
    case "reserved":
      return "chip-yellow-bg chip-yellow-fg";
    default:
      return "";
  }
}

/**
 * The vivid per-status accent used on the canvas (the seat dot's stroke in
 * ChairDot.tsx). Kept next to the chip classes so the two never drift.
 *
 * Used by the guest spotlight so "this is the guest you are pointing at" is
 * carried in the guest's OWN status colour instead of a second, louder blue.
 * An unassigned seat has no accent — the spotlight only ever lands on occupied
 * seats, so the focus colour is a fallback that should not be reachable.
 */
export function seatStatusAccentColor(status: SeatStatus): string {
  switch (status) {
    case "assigned":
      return "#50a866";
    case "checkedIn":
      return "#8b5cf6";
    case "tentative":
      return "#5494ff";
    case "reserved":
      return "#ca8a04";
    default:
      return "var(--color-outline-focus)";
  }
}
